module.exports = __webpack_public_path__ + "img/bg_top.fcf063a8.png";